// Wave AW.3-React (2026-05-16) — 외부 바이어 화면 공통 layout
// 헤더 (로고 + 언어 + 로그아웃) + 가로 네비게이션 바 (탭) — 모든 /buyer/* 화면 재사용
// Wave UX-2.1 Item 1 (2026-05-23) — i18n 4 locale (ko/en/ar/ru). NAV 라벨 + 로그아웃 + 준비중 → t().

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogoFull } from '../Logo';
import { useT } from '../../i18n/I18nProvider';
import LanguageSwitcher from '../../i18n/LanguageSwitcher';
import NotificationBell from './NotificationBell';
import { ToastHost } from './Toast';
import { ConfirmHost, confirm } from './ConfirmDialog';

// labelKey 는 t() 호출용 — locale 별 동적 라벨.
var NAV_ITEMS = [
  { key: 'auctions',  labelKey: 'navAuctions',  icon: '🔨', path: '/buyer/auctions',  enabled: true },
  { key: 'inventory', labelKey: 'navInventory', icon: '🚗', path: '/buyer/inventory', enabled: true },
  { key: 'my-inquiries', labelKey: 'navMyInquiries', icon: '💬', path: '/buyer/my-inquiries', enabled: true },
  { key: 'promise',   labelKey: 'navPromise',   icon: '📋', path: '/buyer/promise',   enabled: true },
  { key: 'bids',      labelKey: 'navMyBids',    icon: '🎯', path: '/buyer/bids',      enabled: true },
  { key: 'favorites', labelKey: 'navFavorites', icon: '⭐', path: '/buyer/favorites', enabled: true },
  { key: 'cart',      labelKey: 'navCart',      icon: '📦', path: '/buyer/cart',      enabled: true },
];

function AuctionBuyerLayout(props) {
  var activeKey = props.activeKey;
  var children = props.children;
  var navigate = useNavigate();
  var t = useT();
  // perf/buyer-iife-lazy (2026-05-24) — useState lazy init (mount 1회) → 매 render IIFE 차단
  var [buyer] = useState(function(){
    try { return JSON.parse(sessionStorage.getItem('autodex_buyer')||'null'); } catch(e) { return null; }
  });

  var handleLogout = function() {
    // Wave UX-2.3 #11 — 실수 클릭 차단 (P2 보완)
    // P2 #8 (2026-05-24) — window.confirm → custom ConfirmDialog (i18n/RTL/모바일 일관)
    confirm({ message: t('logoutConfirm') }).then(function(ok) {
      if (!ok) return;
      localStorage.removeItem('autodex_buyer_token');
      localStorage.removeItem('autodex_buyer_refresh');
      sessionStorage.removeItem('autodex_buyer');
      navigate('/buyer/login');
    });
  };

  return (
    <div className="buyer-root" style={{ minHeight: '100vh', background: '#f8fafc' }}>
      {/* 헤더 */}
      <div style={{
        background: 'white', borderBottom: '1px solid #e2e8f0',
        padding: '14px 32px', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      }}>
        <div style={{ cursor: 'pointer' }} onClick={function(){navigate('/buyer/dashboard')}}>
          <LogoFull iconSize={28} fontSize={18} />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          {buyer && (
            <button type="button" onClick={function(){navigate('/buyer/me');}}
              title={t('meTitle')}
              style={{
                fontSize: 14, color: '#475569', fontWeight: 600,
                background: 'transparent', border: 'none', cursor: 'pointer', padding: '4px 8px',
              }}>
              {buyer.name || buyer.email}
            </button>
          )}
          <NotificationBell />
          <LanguageSwitcher />
          <button type="button" onClick={handleLogout}
            style={{
              padding: '8px 14px', background: 'white',
              border: '1.5px solid #e2e8f0', borderRadius: 8,
              fontSize: 13, fontWeight: 600, color: '#64748b',
              cursor: 'pointer',
            }}>
            {t('commonLogout')}
          </button>
        </div>
      </div>

      {/* 네비게이션 바 (2026-05-24 — justifyContent center 로 4탭 가운데 정렬) */}
      <div style={{
        background: 'white', borderBottom: '1px solid #e2e8f0',
        padding: '0 32px',
        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4,
        overflowX: 'auto',
      }}>
        {NAV_ITEMS.map(function(item) {
          var isActive = activeKey === item.key;
          var disabled = !item.enabled;
          return (
            <button key={item.key} type="button"
              onClick={function(){ if (item.enabled) navigate(item.path); }}
              disabled={disabled}
              style={{
                padding: '14px 18px', background: 'transparent',
                border: 'none',
                borderBottom: isActive ? '2.5px solid #1B3A5C' : '2.5px solid transparent',
                fontSize: 14, fontWeight: isActive ? 700 : 600,
                color: disabled ? '#94a3b8' : (isActive ? '#1B3A5C' : '#475569'),
                cursor: disabled ? 'not-allowed' : 'pointer',                display: 'flex', alignItems: 'center', gap: 6,
                whiteSpace: 'nowrap',
                marginBottom: '-1px',
              }}>
              <span>{item.icon}</span>
              <span>{t(item.labelKey)}</span>
              {disabled && (
                <span style={{ fontSize: 10, fontWeight: 600, background: '#f1f5f9', color: '#94a3b8', padding: '2px 6px', borderRadius: 4, marginLeft: 4 }}>
                  {t('navComingSoon')}
                </span>
              )}
            </button>
          );
        })}
      </div>

      {/* 메인 컨텐츠 */}
      {children}

      {/* Wave UX-2.3 #18 — 공용 토스트 호스트 */}
      <ToastHost />
      {/* P2 #8 — ConfirmHost: window.confirm 대체 (Promise<boolean> API) */}
      <ConfirmHost />
    </div>
  );
}

export default AuctionBuyerLayout;
